export enum ColumnOrientation {
  LEFT,
  RIGHT,
}
